import { Debug } from 'lib/debug';
import config from 'temp/config';

function normalizeSlashes(str: string): string {
  return str.replace(/([^:]\/)\/+/g, '$1');
}

export const rewritePathByHost = (path: string | undefined, check_host: string | undefined) => {
  if (path === null || path === undefined) {
    return '';
  }

  let returnValue = path;
  config.additionalRewrites?.split('&').forEach((entry) => {
    const [host, basePath] = entry.split('=');
    if (!host || !basePath) return;

    if (check_host && path?.indexOf(basePath) > -1 && check_host.indexOf(host) > -1) {
      returnValue = path.replace(basePath, '/');

      if (returnValue !== '/' && returnValue.endsWith('/')) {
        returnValue = returnValue.substring(0, returnValue.length - 1);
      }

      returnValue = normalizeSlashes(returnValue);
      Debug.rewrites('rewritePathByHost:', path, 'to', returnValue, 'for', check_host);
    }
  });

  return returnValue;
};

export const rewritePathByItemPath = (path: string | undefined, item_path: string | undefined) => {
  if (path === null || path === undefined) {
    return '';
  }
  if (item_path === null || item_path === undefined) {
    return path;
  }

  let returnValue = path;
  config.additionalRewrites?.split('&').forEach((entry) => {
    const [host, basePath] = entry.split('=');
    if (!host || !basePath) return;

    if (
      item_path &&
      path?.indexOf(basePath) > -1 &&
      item_path.toLocaleLowerCase().indexOf(basePath) > -1
    ) {
      returnValue = path.replace(basePath, '/');

      if (returnValue !== '/' && returnValue.endsWith('/')) {
        returnValue = returnValue.substring(0, returnValue.length - 1);
      }

      returnValue = normalizeSlashes(returnValue);
      if (returnValue?.startsWith('//')) {
        returnValue = returnValue.replace('//', '/');
      }
      Debug.rewrites('rewritePathByItemPath:', path, 'to', returnValue, 'for item path', item_path);
    }
  });

  return returnValue;
};
